<template>
  <v-form class="cadastro-form">
    <v-row fluid>
      <v-col cols="12">
        <v-stepper v-model="e1" elevation="0" class="cadastro-stepper">
          <v-stepper-header>
            <v-stepper-step
              :complete="stepComplete(1)"
              :rules="[() => !!validPessoais]"
              :color="stepStatus(1)"
              step="1"
              >Dados Pessoais</v-stepper-step
            >
            <v-divider></v-divider>
            <v-stepper-step
              step="2"
              :complete="stepComplete(2)"
              :rules="[() => !!validEndereco]"
              :color="stepStatus(2)"
              >Dados do endereço</v-stepper-step
            >
            <v-divider></v-divider>
            <v-stepper-step
              :complete="stepComplete(3)"
              :rules="[() => !!validDocumento]"
              :color="stepStatus(3)"
              step="3"
              >Documentos
            </v-stepper-step>
            <v-divider></v-divider>
            <v-stepper-step
              :complete="stepComplete(4)"
              :rules="[() => !!validTermos]"
              :color="stepStatus(4)"
              step="4"
              >Termos
            </v-stepper-step>
          </v-stepper-header>

          <v-stepper-items>
            <v-stepper-content step="1">
              <div class="form-section form-section--last">
                <div class="form-section__header">
                  <div class="form-section__icon-wrap">
                    <v-icon color="#0052A0" size="20">mdi-account-outline</v-icon>
                  </div>
                  <div>
                    <div class="form-section__title">Dados Pessoais</div>
                    <div class="form-section__sub">Informe seus dados de identificação e contato</div>
                  </div>
                </div>
                <div class="form-section__body">
                  <v-row dense>
                    <v-col cols="12" md="4">
                      <v-text-field
                        outlined dense color="#0052A0"
                        v-model="etapa_um.name"
                        label="Razão Social"
                        required
                        :rules="nameRule"
                      ></v-text-field>
                    </v-col>
                    <v-col cols="12" md="4">
                      <v-text-field
                        outlined dense color="#0052A0"
                        v-model="etapa_um.cpf_cnpj"
                        label="CPF"
                        v-cpf:model="etapa_um.cpf_cnpj"
                        required
                        :rules="cpfRule"
                      ></v-text-field>
                    </v-col>

                    <v-col cols="12" md="4">
                      <v-text-field
                        outlined dense color="#0052A0"
                        v-model="etapa_um.email"
                        label="E-mail "
                        required
                        disabled
                        :rules="emailRule"
                      ></v-text-field>
                    </v-col>
                    <v-col cols="12" md="4">
                      <v-text-field
                        outlined dense color="#0052A0"
                        v-model="etapa_um.telefone"
                        label="Telefone"
                        v-phone:model="etapa_um.telefone"
                        required
                        :rules="telefoneRule"
                      ></v-text-field>
                    </v-col>
                    <v-col cols="12" md="4">
                      <v-text-field
                        outlined dense color="#0052A0"
                        v-model="etapa_um.whats"
                        label="WhatsApp"
                        required
                        :rules="whatsRule"
                        v-phone:model="etapa_um.whats"
                      ></v-text-field>
                    </v-col>
                  </v-row>
                </div>
              </div>
              <div class="form-actions">
                <v-btn color="#0052A0" rounded elevation="0" @click="validate(1)" class="px-6">
                  <v-icon left color="#FFD400" small>mdi-arrow-right</v-icon>
                  <span style="color:#FFD400;font-weight:700;font-size:13px">Avançar</span>
                </v-btn>
              </div>
            </v-stepper-content>

            <v-stepper-content step="2">
              <div class="form-section form-section--last">
                <div class="form-section__header">
                  <div class="form-section__icon-wrap">
                    <v-icon color="#0052A0" size="20">mdi-map-marker-outline</v-icon>
                  </div>
                  <div>
                    <div class="form-section__title">Dados do Endereço</div>
                    <div class="form-section__sub">Informe o endereço para contato e correspondência</div>
                  </div>
                </div>
                <div class="form-section__body">
                  <v-row dense>
                    <v-col cols="12" md="2">
                      <v-text-field
                        v-model="etapa_dois.cep"
                        label="CEP"
                        required
                        :rules="cepRule"
                        v-cep:model="etapa_dois.cep"
                        outlined dense color="#0052A0"
                      ></v-text-field>
                    </v-col>
                    <v-col cols="12" md="4">
                      <v-text-field
                        v-model="etapa_dois.municipio"
                        label="Município"
                        required
                        :rules="municipioRule"
                        outlined dense color="#0052A0"
                      ></v-text-field>
                    </v-col>
                    <v-col cols="12" md="2">
                      <v-text-field
                        v-model="etapa_dois.uf"
                        label="UF"
                        required
                        :rules="ufRule"
                        outlined dense color="#0052A0"
                      ></v-text-field>
                    </v-col>
                    <v-col cols="12" md="4">
                      <v-text-field
                        v-model="etapa_dois.endereco"
                        label="Endereço "
                        required
                        :rules="enderecoRule"
                        outlined dense color="#0052A0"
                      ></v-text-field>
                    </v-col>
                    <v-col cols="12" md="3">
                      <v-text-field
                        v-model="etapa_dois.complemento"
                        label="Complemento"
                        required
                        :rules="complementoRule"
                        outlined dense color="#0052A0"
                      ></v-text-field>
                    </v-col>
                    <v-col cols="12" md="2">
                      <v-text-field
                        v-model="etapa_dois.numero"
                        label="Nº"
                        required
                        :rules="numeroRule"
                        outlined dense color="#0052A0"
                      ></v-text-field>
                    </v-col>
                    <v-col cols="12" md="3">
                      <v-text-field
                        v-model="etapa_dois.bairro"
                        label="Bairro"
                        required
                        :rules="bairroRule"
                        outlined dense color="#0052A0"
                      ></v-text-field>
                    </v-col>
                  </v-row>
                </div>
              </div>
              <div class="form-actions">
                <v-btn text rounded color="grey darken-1" @click="e1 = 1">
                  <v-icon left small>mdi-arrow-left</v-icon>Voltar
                </v-btn>
                <v-btn color="#0052A0" rounded elevation="0" @click="validate(2)" class="px-6">
                  <v-icon left color="#FFD400" small>mdi-arrow-right</v-icon>
                  <span style="color:#FFD400;font-weight:700;font-size:13px">Avançar</span>
                </v-btn>
              </div>
            </v-stepper-content>

            <v-stepper-content step="3">
              <div class="form-section form-section--last">
                <div class="form-section__header">
                  <div class="form-section__icon-wrap">
                    <v-icon color="#0052A0" size="20">mdi-file-document-outline</v-icon>
                  </div>
                  <div>
                    <div class="form-section__title">Documentos</div>
                    <div class="form-section__sub">Envie os documentos para validação do cadastro</div>
                  </div>
                </div>
                <div class="form-section__body">
                  <div class="field-group-label">Documento de identificação</div>
                  <v-row dense>
                    <v-col cols="12" md="3">
                      <v-checkbox
                        v-model="rg"
                        label="RG"
                        @change="rgAction"
                        color="#0052A0"
                        class="shrink mr-2 mt-0"
                        hide-details
                      ></v-checkbox>
                      <v-checkbox
                        v-model="cnh"
                        label="CNH"
                        @change="cnhAction"
                        color="#0052A0"
                        class="shrink mr-2 mt-0"
                        hide-details
                      ></v-checkbox>
                    </v-col>

                    <v-col cols="12" md="4">
                      <v-file-input
                        v-if="rg"
                        v-model="etapa_tres.rg_frente"
                        label="RG Frente"
                        :disabled="!rg"
                        accept="image/*, application/pdf"
                        outlined dense color="#0052A0"
                        prepend-inner-icon="mdi-paperclip"
                        prepend-icon=""
                        :rules="rgFrenteRule"
                      ></v-file-input>
                      <v-file-input
                        v-if="rg"
                        v-model="etapa_tres.rg_verso"
                        label="RG Verso"
                        :disabled="!rg"
                        accept="image/*, application/pdf"
                        outlined dense color="#0052A0"
                        prepend-inner-icon="mdi-paperclip"
                        prepend-icon=""
                        :rules="rgVersoRule"
                      ></v-file-input>
                      <v-file-input
                        v-if="cnh"
                        v-model="etapa_tres.cnh_documento"
                        label="CNH"
                        :disabled="!cnh"
                        accept="image/*, application/pdf"
                        outlined dense color="#0052A0"
                        prepend-inner-icon="mdi-paperclip"
                        prepend-icon=""
                        :rules="cnhRule"
                      ></v-file-input>
                    </v-col>
                    <v-col cols="12" md="5">
                      <div class="field-group-label">Comprovante de endereço</div>
                      <v-file-input
                        v-model="etapa_tres.comprovante_endereco"
                        label="Comprovante de endereço atualizado"
                        accept="image/*, application/pdf"
                        outlined dense color="#0052A0"
                        prepend-inner-icon="mdi-paperclip"
                        prepend-icon=""
                        :rules="comprovanteRule"
                      ></v-file-input>
                    </v-col>
                  </v-row>
                </div>
              </div>
              <div class="form-actions">
                <v-btn text rounded color="grey darken-1" @click="e1 = 2">
                  <v-icon left small>mdi-arrow-left</v-icon>Voltar
                </v-btn>
                <v-btn color="#0052A0" rounded elevation="0" @click="validate(3)" class="px-6">
                  <v-icon left color="#FFD400" small>mdi-arrow-right</v-icon>
                  <span style="color:#FFD400;font-weight:700;font-size:13px">Avançar</span>
                </v-btn>
              </div>
            </v-stepper-content>

            <v-stepper-content step="4">
              <div class="form-section form-section--last">
                <div class="form-section__header">
                  <div class="form-section__icon-wrap">
                    <v-icon color="#0052A0" size="20">mdi-file-check-outline</v-icon>
                  </div>
                  <div>
                    <div class="form-section__title">Termos de Uso</div>
                    <div class="form-section__sub">Leia e aceite os termos para concluir o cadastro</div>
                  </div>
                </div>
                <div class="form-section__body">
                  <v-row dense>
                    <v-col cols="12">
                      <div class="termos-box">
                        <!-- Termo cadastrado no admin (HTML), igual ao cadastro de empresa -->
                        <div class="text-justify" v-html="text_termo" />
                      </div>

                      <v-lazy
                        v-model="isActive"
                        :options="{
                          threshold: 1,
                        }"
                        min-height="60"
                        transition="fade-transition"
                      >
                        <v-checkbox
                          v-model="etapa_quatro.termos"
                          label="ACEITO OS TERMOS DE USO"
                          color="#0052A0"
                          hide-details
                        ></v-checkbox>
                      </v-lazy>
                    </v-col>
                  </v-row>
                </div>
              </div>

              <div class="form-actions">
                <v-btn text rounded color="grey darken-1" @click="e1 = 3">
                  <v-icon left small>mdi-arrow-left</v-icon>Voltar
                </v-btn>
                <v-btn
                  color="#0052A0" rounded elevation="0"
                  :disabled="!etapa_quatro.termos"
                  @click="validate(4)"
                  class="px-6"
                >
                  <v-icon left color="#FFD400" small>mdi-check</v-icon>
                  <span style="color:#FFD400;font-weight:700;font-size:13px">Concluir Cadastro</span>
                </v-btn>
              </div>
            </v-stepper-content>
          </v-stepper-items>
        </v-stepper>
      </v-col>
    </v-row>
  </v-form>
</template>

<script>
import { isCPF } from "vuetify-masks-br";

import axios from "axios";
import { mapActions } from "vuex";
export default {
  mounted() {
    this.etapa_um.name = this.$store.state.auth.user.name;
    this.etapa_um.email = this.$store.state.auth.user.email;
    this.termo()
     if(!this.$store.state.auth.user.user_juridica){
      this.e1 = (this.$store.state.auth.user.etapa == null)?1:this.$store.state.auth.user.etapa + 1
    }
  },

  data: () => ({
    e1: 1,
    rg: true,
    cnh: false,
    isActive: false,
    text_termo: '',
    etapa_um: {
      name: "",
      email: "",
      cpf_cnpj: "43812993880",
      telefone: "(11) 9 1523-1235",
      whats: "(11) 9 1523-1235",
      etapa_um: 1,
    },
    etapa_dois: {
      endereco: "fsdfsfsdfsdf",
      complemento: "asdas",
      uf: "asdas",
      numero: "1",
      bairro: "dasdas",
      municipio: "adasd",
      cep: "46430-000",
      cepConvertido: "",
      etapa_dois: 2,
    },
    etapa_tres: {
      cnh: false,
      rg: true,
      user_juridica: false,
      etapa_tres: 3,
      comprovante_endereco: null,
      rg_frente: null,
      rg_verso: null,
      cnh_documento: null,
    },
    etapa_quatro: {
      termos: false,
      etapa_quatro: 4,
      
    },
    validPessoais: true,
    validEndereco: true,
    validTermos: true,
    validDocumento: true,

    cpfRule: [
      (v) => !!v || "CPF é obrigatório",
      (v) => isCPF(v || "") || "CPF não é válido.",
    ],
    nameRule: [
      (v) => !!v || "Nome é obrigatória",
      (v) => v.length >= 5 || "Mínimo de 5 caracteres",
    ],
    emailRule: [
      (v) => !!v || "E-mail é obrigatória",
      (v) => /.+@.+\..+/.test(v) || "insira um e-mail E-mail ",
    ],
    telefoneRule: [
      (v) => !!v || "Telefone é obrigatória",
      (v) => v.length >= 14 || "Preencha todo campo",
    ],
    whatsRule: [
      (v) => !!v || "WhatsApp é obrigatória",
      (v) => v.length >= 14 || "Preencha todo campo",
    ],
    cepRule: [(v) => !!v || "CEP é obrigatória"],
    municipioRule: [(v) => !!v || "Município é obrigatória"],
    ufRule: [(v) => !!v || "UF é obrigatória"],
    enderecoRule: [(v) => !!v || "Endereço é obrigatória"],
    complementoRule: [(v) => !!v || "Complemento é obrigatória"],
    numeroRule: [(v) => !!v || "Nº é obrigatória"],
    bairroRule: [(v) => !!v || "Bairro é obrigatória"],

    comprovanteRule: [
      (value) => !value || value.size < 2000000 || "Tamanho máximo é 2MB!",
      (v) => !!v || "Comprovante é obrigatória",
    ],
    rgFrenteRule: [
      (value) => !value || value.size < 2000000 || "Tamanho máximo é 2MB!",
    ],
    rgVersoRule: [
      (value) => !value || value.size < 2000000 || "Tamanho máximo é 2MB!",
    ],
    cnhRule: [
      (value) => !value || value.size < 2000000 || "Tamanho máximo é 2MB!",
    ],
  }),

  methods: {
    ...mapActions("auth", ["registerCompleteFile", "ActionRegisterComplete"]),
    async submit() {
      this.form.cpf_cnpj = this.form.cpf_cnpj.replace(/([^\d])+/gim, "");
      this.form.telefone = this.form.telefone.replace(/([^\d])+/gim, "");
      this.form.whats = this.form.whats.replace(/([^\d])+/gim, "");
      this.form.cep = this.form.cep.replace(/([^\d])+/gim, "");

      try {
        const data = await this.ActionRegisterComplete(this.form);
        console.log(data);
        this.$router.push({ name: "home" });
      } catch (error) {
        console.log(error);
      }
    },
    Cadastar() {
      this.$router.push({ name: "home" });
    },
    stepComplete(step) {
      return this.e1 > step;
    },
    stepStatus(n) {
      return this.e1 > n ? "#22c55e" : "#0052A0";
    },
    async validate(n) {
      if (n == 1) {
        if (
          this.etapa_um.name == "" ||
          this.etapa_um.cpf_cnpj == "" ||
          this.etapa_um.whats == "" ||
          this.etapa_um.email == "" ||
          this.etapa_um.telefone == ""
        ) {
          this.validPessoais = false;
        } else {
          this.etapa_um.cpf_cnpj = this.etapa_um.cpf_cnpj.replace(
            /([^\d])+/gim,
            ""
          );
          this.etapa_um.telefone = this.etapa_um.telefone.replace(
            /([^\d])+/gim,
            ""
          );
          this.etapa_um.whats = this.etapa_um.whats.replace(/([^\d])+/gim, "");
          this.validPessoais = true;
          try {
            const data = await this.ActionRegisterComplete(this.etapa_um);
            console.log(data);
            this.e1 = n + 1;
          } catch (erro) {
            this.$swal({
              toast: true,
              position: "bottom",
              showConfirmButton: false,
              background: "#ff0000",
              timer: 3000,
              icon: "error",
              title: '<span style="color:#FFF">Desculpe</span>',
              html: '<span style="color:#FFF">CPF/CNPJ já existe</span>',
            });
          }
        }
      }
      if (n == 2) {
        if (
          this.etapa_dois.cep == "" ||
          this.etapa_dois.municipio == "" ||
          this.etapa_dois.uf == "" ||
          this.etapa_dois.endereco == "" ||
          this.etapa_dois.numero == "" ||
          this.etapa_dois.bairro == ""
        ) {
          this.validEndereco = false;
        } else {
          this.etapa_dois.cepConvertido = this.etapa_dois.cep.replace(
            /([^\d])+/gim,
            ""
          );
          this.validEndereco = true;
          try {
            const data = await this.ActionRegisterComplete(this.etapa_dois);
            data;
            this.e1 = n + 1;
          } catch (erro) {
            erro;
          }
        }
      }
      if (n == 3) {
        if (this.etapa_tres.comprovante_endereco == null) {
          this.validDocumento = false;
          this.notificacao("Por favor", "Preencha todos os campos");
        } else {
          let formData = new FormData();
          formData.append("etapa_tres", this.etapa_tres.etapa_tres);
          formData.append("user_juridica", this.etapa_tres.user_juridica);
          formData.append(
            "comprovante_endereco",
            this.etapa_tres.comprovante_endereco
          );

          if (this.etapa_tres.rg) {
            if (
              this.etapa_tres.rg_frente != null &&
              this.etapa_tres.rg_verso != null
            ) {
              formData.append("cnh", this.etapa_tres.cnh);
              formData.append("rg", this.etapa_tres.rg);

              formData.append("rg_frente", this.etapa_tres.rg_frente);
              formData.append("rg_verso", this.etapa_tres.rg_verso);
              formData.append("cnh_documento", this.etapa_tres.cnh_documento);
              this.sendArquivos(formData);
            } else {
              this.validDocumento = false;
              this.notificacao("Por favor", "Preencha todos os campos");
            }
          } else if (this.etapa_tres.cnh) {
            if (this.etapa_tres.cnh_documento != null) {
              formData.append("cnh", this.etapa_tres.cnh);
              formData.append("rg", this.etapa_tres.rg);

              formData.append("rg_frente", this.etapa_tres.rg_frente);
              formData.append("rg_verso", this.etapa_tres.rg_verso);
              formData.append("cnh_documento", this.etapa_tres.cnh_documento);
              this.sendArquivos(formData);
            } else {
              this.validDocumento = false;
              this.notificacao("Por favor", "Preencha todos os campos");
            }
          } else {
            this.notificacao("Por favor", "Preencha todos os campos");
            this.validDocumento = false;
          }
        }
      }
      if (n == 4) {

         if (this.etapa_quatro.termos) {
           try {
            const data = await this.ActionRegisterComplete(this.etapa_quatro);
            data;
            this.e1 = n + 1;
          } catch (erro) {
            erro;
          }
         }else{
            this.validTermos = false
         }
        
      }
    },
    async sendArquivos(formdata) {
      try {
        const data = await this.registerCompleteFile(formdata);
        if (data.data.erro) {
          this.notificacao("Erro", data.data.message);
          this.validDocumento = false;
        } else {
          this.validDocumento = true;
          this.e1 = 4;
           this.$router.push({ name: "home" });
        }
      } catch (erro) {
        erro;
      }
    },
     termo(){
      // Termo vigente do Negativa (mesmo endpoint do cadastro de empresa).
      // Antes: URL fixa api/auth/termo, que não existe (404).
      this.$http.get('termo/showVigencia').then(response => {
          this.text_termo = response.data && response.data.texto ? response.data.texto : ''
        }, () => {
          this.text_termo = ''
        });
    },

    rgAction(newValue) {
      this.etapa_tres.rg = newValue;
      this.etapa_tres.cnh = !newValue;
      this.cnh = !newValue;
      this.etapa_tres.cnh_documento = null;
    },
    cnhAction(newValue) {
      this.etapa_tres.cnh = newValue;
      this.etapa_tres.rg = !newValue;
      this.rg = !newValue;
      this.etapa_tres.rg_verso = null;
      this.etapa_tres.rg_frente = null;
    },

    notificacao(title, msg) {
      this.$swal({
        toast: true,
        position: "center-end",
        showConfirmButton: false,
        timer: 3000,
        icon: "error",
        title: title,
        text: msg,
      });
    },
  },

  watch: {
    "etapa_dois.cep": function (newValue) {
      var vm = this.etapa_dois;
      var values = this;

      var local = newValue.replace(/([^\d])+/gim, "");
      if (local.length == 8) {
        axios
          .get("https://viacep.com.br/ws/" + local + "/json/")
          .then(function (res) {
            if (!res.data.erro) {
              vm.municipio = res.data.localidade;
              vm.uf = res.data.uf;
              vm.bairro = res.data.bairro;
              vm.endereco = res.data.logradouro;
            } else {
              values.$swal({
                toast: true,
                position: "center-end",
                showConfirmButton: false,
                background: "#ff0000",
                timer: 3000,
                icon: "error",
                title: '<span style="color:#FFF">Desculpe</span>',
                html: '<span style="color:#FFF">CEP não encontrado</span>',
              });
            }
          })
          .catch(function (err) {
            err;
          });
      }
    },
  },
};
</script>

<style scoped>
.cadastro-stepper {
  box-shadow: none !important;
}

/* ─── Seções do form ────────────────────────────────── */
.form-section {
  border-bottom: 1px solid #f1f5f9;
  padding-bottom: 32px;
  margin-bottom: 32px;
}
.form-section--last {
  border-bottom: none;
  padding-bottom: 0;
  margin-bottom: 0;
}
.form-section__header {
  display: flex;
  align-items: flex-start;
  gap: 12px;
  padding: 0 0 18px 0;
}
.form-section__icon-wrap {
  width: 34px; height: 34px;
  background: #e8f0fe;
  border-radius: 8px;
  display: flex; align-items: center; justify-content: center;
  flex-shrink: 0;
  margin-top: 2px;
}
.form-section__title {
  font-family: 'Inter', sans-serif;
  font-size: 0.92rem;
  font-weight: 700;
  color: #1e293b;
}
.form-section__sub {
  font-family: 'Inter', sans-serif;
  font-size: 0.78rem;
  color: #94a3b8;
  margin-top: 1px;
}
.form-section__body {
  padding: 0;
}

/* ─── Labels de grupo ───────────────────────────────── */
.field-group-label {
  font-family: 'Inter', sans-serif;
  font-size: 0.7rem;
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: 0.8px;
  color: #94a3b8;
  margin-bottom: 10px;
}

/* ─── Termos de uso ─────────────────────────────────── */
.termos-box {
  max-height: 260px;
  overflow-y: auto;
  border: 1px solid #e2e8f0;
  border-radius: 8px;
  padding: 16px 20px;
  margin-bottom: 16px;
  background: #f8fafc;
}
.termos-box p {
  font-family: 'Inter', sans-serif;
  font-size: 0.85rem;
  color: #1e293b;
  margin: 0;
}

/* ─── Ações do formulário ───────────────────────────── */
.form-actions {
  display: flex;
  justify-content: flex-end;
  align-items: center;
  gap: 8px;
  padding: 24px 0 8px;
}

/* ─── Inputs ─────────────────────────────────────────── */
.cadastro-form >>> .v-input__slot {
  background-color: #fff !important;
  box-shadow: none !important;
}
.cadastro-form >>> .v-label {
  font-family: 'Inter', sans-serif !important;
  font-size: 0.85rem !important;
}
.cadastro-form >>> input,
.cadastro-form >>> .v-select__selections {
  font-family: 'Inter', sans-serif !important;
  font-size: 0.88rem !important;
  color: #1e293b !important;
}

@media (max-width: 768px) {
  .form-actions { justify-content: space-between; }
}
</style>
